"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = exports.default = {
  name: 'wl-image',
  /* 混入 */
  props: {
    value: {
      type: [Object, Array, String],
      default: ''
    },
    src: {
      type: [Object, Array, String],
      default: ''
    },
    isFull: {
      type: Boolean,
      default: false
    },
    previewSrcList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      image: '',
      imageLoading: '',
      srcIndex: 0,
      LoadingIndex: 0
    };
  },
  watch: {},
  computed: {
    getSrc: function getSrc() {
      if (typeof this.src === 'string') return this.src;else if (Array.isArray(this.src)) return this.src[0];
      return '';
    }
  },
  methods: {
    /** 图片加载成功
     * @param { Object } e 事件
     * @return { void }
     */
    load: function load(e) {
      this.$$listenersEmit('load', this.src, e);
      this.LoadingIndex++;
      this.srcIndex = this.LoadingIndex - 1;
    },
    /** 图片加载失败
     * @param { String } src 图片链接
     * @param { Object } e 点击事件
     * @return { void }
     */
    error: function error(src, e) {
      this.$emit('error', src, e);
    }
  },
  created: function created() {
    this.image = this.getSrc;
  }
};